import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {InvoiceStatusType} from "../../types/invoice-status.type";

export class BillingOrderInvoiceStatusMultiSelectListComponent implements IController {
  statuses: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;
  private queryString: any;

  constructor() {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = Object.values(InvoiceStatusType);
    }
  }

  $onChanges(changes) {
    if (changes.statuses) {
      this.selectedKeys = [];
      _.forEach(this.statuses, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      statuses: isSelected ? _.concat(this.statuses, [option]) :
        _.filter(this.statuses, (type) => {
          return type !== option;
        })
    });
  }


  submitQuery(query) {
    this.queryString = query;
  }

  onReset() {
    this.onChange({statuses: []});
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('billingOrderInvoiceStatusMultiSelectList', {
    bindings: {
      statuses: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./billing-order-invoice-status-multi-select-list.html').default,
    controller: BillingOrderInvoiceStatusMultiSelectListComponent
  });

